import { consumption_unit_enum } from '@predium/enums';
import { Trans, getI18n } from 'react-i18next';

export const translateConsumptionUnitEnum_selectOptions = (enumValue: consumption_unit_enum) => {
  switch (enumValue) {
    case consumption_unit_enum.KWH:
      return <Trans i18nKey="Enum_ConsumptionUnitEnum-selectOptions-KWH" />;
    case consumption_unit_enum.M3:
      return <Trans i18nKey="Enum_ConsumptionUnitEnum-selectOptions-M3" />;
    case consumption_unit_enum.MWh:
      return <Trans i18nKey="Enum_ConsumptionUnitEnum-selectOptions-MWh" />;
    case consumption_unit_enum.T:
      return <Trans i18nKey="Enum_ConsumptionUnitEnum-selectOptions-T" />;
    case consumption_unit_enum.WH:
      return <Trans i18nKey="Enum_ConsumptionUnitEnum-selectOptions-WH" />;
    case consumption_unit_enum.kg:
      return <Trans i18nKey="Enum_ConsumptionUnitEnum-selectOptions-kg" />;
    case consumption_unit_enum.l:
      return <Trans i18nKey="Enum_ConsumptionUnitEnum-selectOptions-l" />;
  }
};

export const translateConsumptionUnitEnum_selectOptions_dynamic = (enumValue: consumption_unit_enum) => {
  const t = getI18n().t;
  switch (enumValue) {
    case consumption_unit_enum.KWH:
      return t('Enum_ConsumptionUnitEnum-selectOptions-KWH');
    case consumption_unit_enum.M3:
      return t('Enum_ConsumptionUnitEnum-selectOptions-M3');
    case consumption_unit_enum.MWh:
      return t('Enum_ConsumptionUnitEnum-selectOptions-MWh');
    case consumption_unit_enum.T:
      return t('Enum_ConsumptionUnitEnum-selectOptions-T');
    case consumption_unit_enum.WH:
      return t('Enum_ConsumptionUnitEnum-selectOptions-WH');
    case consumption_unit_enum.kg:
      return t('Enum_ConsumptionUnitEnum-selectOptions-kg');
    case consumption_unit_enum.l:
      return t('Enum_ConsumptionUnitEnum-selectOptions-l');
  }
};
